import { render, staticRenderFns } from "./new-store-recommend.vue?vue&type=template&id=0cab478d&scoped=true"
import script from "./new-store-recommend.vue?vue&type=script&lang=js"
export * from "./new-store-recommend.vue?vue&type=script&lang=js"
import style0 from "./new-store-recommend.vue?vue&type=style&index=0&id=0cab478d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cab478d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cab478d')) {
      api.createRecord('0cab478d', component.options)
    } else {
      api.reload('0cab478d', component.options)
    }
    module.hot.accept("./new-store-recommend.vue?vue&type=template&id=0cab478d&scoped=true", function () {
      api.rerender('0cab478d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/public/new-store-recommend.vue"
export default component.exports